<template>
  <div class="yyheader">
    <el-row>
      <el-col :span="4" class="arrowLeft">
        <span class="el-icon-arrow-left" @click="gobackOne"></span>
      </el-col>
      <el-col
        :span="15"
        style="line-height: 60px; font-size: 20px; padding-left: 16px"
      >
        <span>{{ title }}</span>
      </el-col>
      <el-col :span="4">
        <p class="userInfo">
          <img
            v-if="!isHome"
            style="
              display: block;
              margin-right: 5px;
              width: 28px;
              float: left;
              margin-top: 20px;
            "
            src="../assets/admin.png"
            alt=""
          />
          <img
            v-else
            style="
              display: block;
              margin-right: 5px;
              width: 28px;
              float: left;
              margin-top: 20px;
            "
            src="../assets/iswhiteuser.png"
            alt=""
          />
          <span>{{ userInfo.account }}</span>

          <el-popover placement="bottom" width="200" trigger="click">
            <ul>
              <li
                style="
                  font-size: 16px;
                  line-height: 48px;
                  border-bottom: 1px solid #e3e5e8;
                "
              >
                <img
                  style="
                    display: block;
                    width: 28px;
                    float: left;
                    margin-top: 12px;
                    margin-right: 8px;
                  "
                  src="../assets/admin.png"
                  alt=""
                />{{ userInfo.account }}
              </li>
              <li
                @click="loign_out"
                style="font-size: 16px; line-height: 48px; cursor: pointer"
              >
                退出登录
                <img
                  style="
                    float: right;
                    margin-top: 15px;
                    width: 20px;
                    margin-right: 10px;
                  "
                  src="../assets/login_out.png"
                  alt=""
                />
              </li>
            </ul>
            <i
              style="margin-left: 20px; cursor: pointer"
              slot="reference"
              class="el-icon-caret-bottom"
            ></i>
          </el-popover>
        </p>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "headTop",
  props: ["title", "getleft", "showUser", "isHome"],
  data() {
    return {
      userInfo: { account: "" },
    };
  },
  mounted() {
    let useInfo = localStorage.getItem("userInfo");
    this.userInfo = this.$store.getters.userinfo || JSON.parse(useInfo);
  },
  methods: {
    gobackOne() {
      if (this.title == "用户详情") {
        this.$router.push({ path: "/authFront/userManage" });
      } else {
        this.$router.push({ path: "/authFront/home" });
      }
    },
    loign_out() {
      let self = this;
      self.$http.get(
        self.api.logout,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        },
        function (response) {
          if (response.code == 200) {
            self.$message({
              message: "注销成功",
              type: "success",
            });
            self.$router.push({ path: "/authFront/login" });
          }
        },
        function (response) {
          console.log(response);
          //失败回调
        }
      );
      // logout
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-popover {
  width: 200px;
  padding: 0px 15px;
}
.arrowLeft {
  line-height: 60px;
  cursor: pointer;
}
.arrowLeft span.left {
  width: 32px;
  height: 32px;
  display: inline-block;
  background: #ffffff;
  box-shadow: 0px 0px 9px 0px rgb(0 0 0 / 12%);
  border-radius: 20px;
  margin-left: 20px;
  margin-right: 13px;
  line-height: 32px;
  text-align: center;
}
.arrowLeft span i {
  color: #0266fc;
}
.zx {
  display: block;
  float: right;
  margin-top: 12px;
}
.yyheader {
  height: 64px;
  background: #ffffff;
  border-bottom: 1px solid #e3e5e8;
}
.goHome {
  font-size: 20px;
  font-weight: 600;
  color: #333333;
  line-height: 64px;
  float: left;
}
.userInfo {
  float: right;
  margin-right: -40px;
}
.userInfo span {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 64px;
  display: inline-block;
  vertical-align: text-bottom;
}
.el-icon-arrow-left {
  font-size: 20px;
  line-height: 60px;
  text-indent: 20px;
  font-weight: bold;
}
.isnoneback {
  background: none;
  border-bottom: none;
}
.isnoneback .userInfo span {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/headTopTwo.vue